import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import OverLayLoader from '../../components/OverLayLoader';
import SubviewContainer from '../../components/SubviewContainer';
import AddLinkForm from '../../components/AddLinkForm';

import { createLink } from '../../services';
import useTitle from '../../hooks/useTitle';
import { RELATIONS } from '../../helpers/options';
import PATH from '../../helpers/routes.json';
import { createErrorNotification } from '../../utils/createErrorNotification';
import statusCodes from '../../utils/statusCodes';
import { useAuth } from '../../context/auth/AuthContext';

const AddComplexLinkView = () => {
  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { language } = useParams();

  const { user } = useAuth();

  const { t } = useTranslation(['services', 'promptbar']);
  const currentRelationType = RELATIONS.COMPLEX;

  const title = t(`promptbar:addLink`);
  const subtitle = t('common:pages.dictionaries.tabs.complex_code');
  const pageTitle = t('promptbar:pageTitle', {
    title: `${title} | ${subtitle} `,
  });

  useTitle(pageTitle);

  const gotoPath = PATH.dictionaries.tabs.complex_code;

  useEffect(() => {
    if (!user) {
      return;
    }

    setProfiles(user.profiles);
  }, [user]);

  const formSubmitHandler = async data => {
    try {
      setIsLoading(true);
      await createLink(data);
      navigate(gotoPath);
    } catch (error) {
      if (
        error?.response?.status === statusCodes.HTTP_422_UNPROCESSABLE_ENTITY &&
        error?.response?.data?.detail
      ) {
        createErrorNotification(error.response.data.detail);
      } else {
        createErrorNotification();
      }

      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelHandler = () => {
    navigate(gotoPath);
  };

  return (
    <SubviewContainer title={title}>
      {isLoading && <OverLayLoader />}
      <Box sx={{ padding: '3rem 2rem 2rem' }}>
        <AddLinkForm
          currentLanguage={language}
          profiles={profiles}
          relationType={currentRelationType}
          defaultCoefficient="2"
          onSubmit={formSubmitHandler}
          onCancel={cancelHandler}
        />
      </Box>
    </SubviewContainer>
  );
};

export default AddComplexLinkView;
